// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__QkiwJ","cell":"ColumnAccessor_cell__2Jr8l","firstCellAccent":"ColumnAccessor_firstCellAccent__1jAv4"};